export default __webpack_public_path__ + "static/media/primeicons.10d31521.woff";